import React from "react";

type CrudModalProps = {
  title: string;
  open: boolean;
  mode: "create" | "edit" | "view";
  canWrite: boolean;
  saving?: boolean;
  onClose: () => void;
  formId?: string;
  children: React.ReactNode;
};

export const CrudModal: React.FC<CrudModalProps> = ({
  title,
  open,
  mode,
  canWrite,
  saving,
  onClose,
  formId,
  children,
}) => {
  if (!open) {
    return null;
  }

  const showSave = canWrite && mode !== "view";

  return (
    <div className="modal d-block" tabIndex={-1} role="dialog">
      <div className="modal-dialog modal-lg modal-fullscreen-sm-down" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onClose} disabled={saving} />
          </div>
          <div className="modal-body">{children}</div>
          <div className="modal-footer">
            <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={saving}>
              Cancelar
            </button>
            {showSave && (
              <button className="btn btn-primary" type="submit" form={formId} disabled={saving}>
                {saving ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Salvando...
                  </>
                ) : (
                  "Salvar"
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
